import React, { useMemo } from 'react';
import { Form, FormFields, FormProps } from '@rollioforce/rollio-admin-ui';

type SfLoginType = {
  email: string;
};

export interface SfLoginFormProps extends Partial<FormProps> {
  initialData?: SfLoginType;
  onSubmit: (formDetails: SfLoginType) => void;
}

export const DEFAULT_SF_LOGIN_FORM = {
  email: '',
};

export const SfLoginForm: React.FC<SfLoginFormProps> = ({
  initialData,
  ...props
}) => {
  const formData = useMemo(() => {
    return {
      ...DEFAULT_SF_LOGIN_FORM,
      ...initialData,
    };
  }, [initialData]);

  const FORM_FIELDS: FormFields = useMemo(
    () => [
      {
        key: 'email',
        label: 'Email',
        type: 'input',
        validate: 'onChange',
      },
    ],
    []
  );

  return (
    <Form
      {...props}
      fields={FORM_FIELDS}
      enableReinitialize
      initialData={formData}
    />
  );
};
